import { ShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useContext, useEffect, useState } from 'react';
import { tss } from 'tss-react';

import CreateButton from 'components/desktop/ShoppingCart/Search/misc/CreateButton';
import ApprovedTab from 'components/desktop/ShoppingCart/Search/tabs/ApprovedTab';
import LiveTab from 'components/desktop/ShoppingCart/Search/tabs/LiveTab';
import ReviewTab from 'components/desktop/ShoppingCart/Search/tabs/ReviewTab';
import LoadingAnimation from 'components/desktop/_general/Loading/LoadingAnimation';
import Tabs from 'components/desktop/_general/Tabs/Tabs';
import useTranslation from 'hooks/useTranslation';

const ShoppingCartSearchComponent = () => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const { initializeWithoutDetails } = useContext(ShoppingCartsContext);

	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const fetchCarts = async () => {
			setIsLoading(true);
			await initializeWithoutDetails();
			setIsLoading(false);
		};
		fetchCarts();
	}, []);

	return (
		<div className={classes.container}>
			<LoadingAnimation isLoading={isLoading}></LoadingAnimation>
			{!isLoading && (
				<>
					<div className={classes.head}>
						<h1>{t('header:SHOPPING_CART')}</h1>
						<CreateButton />
					</div>
					<Tabs
						tabs={[
							{
								name: t('shoppingCart:OPEN'),
								content: <LiveTab />,
							},
							{
								name: t('shoppingCart:IN_REVIEW'),
								content: <ReviewTab />,
							},
							{
								name: t('shoppingCart:CLOSED'),
								content: <ApprovedTab />,
							},
						]}
					/>
				</>
			)}
		</div>
	);
};

export default ShoppingCartSearchComponent;

export const useStyles = tss.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
	},
	head: {
		display: 'flex',
		justifyContent: 'space-between',
	},
});
